module.exports = __webpack_public_path__ + "static/media/confirm.3453076e.svg";